import React, { useEffect, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { LayoutSplashScreen } from '../../../../_metronic/layout/_core/MetronicSplashScreen'
import * as auth from './authRedux'
import { getUserByToken } from './authCrud'

const AuthInit = ({ children }) => {
	const requestedTokenRef = useRef(null)
	const dispatch = useDispatch()
	const [showSplashScreen, setShowSplashScreen] = useState(true)
	const authToken = useSelector(({ auth }) => auth.authToken, shallowEqual)
	const user = useSelector(({ auth }) => auth.user, shallowEqual)

	// We should request user by authToken before rendering the application
	useEffect(() => {
		let isMounted = true

		const requestUser = async () => {
			if (!authToken) {
				if (user) {
					dispatch(auth.actions.logout())
				}
				if (isMounted) {
					setShowSplashScreen(false)
				}
				return
			}

			if (requestedTokenRef.current === authToken) {
				if (isMounted) {
					setShowSplashScreen(false)
				}
				return
			}

			requestedTokenRef.current = authToken

			try {
				const data = await getUserByToken()
				if (data) {
					dispatch(auth.actions.fulfillUser(data))
				}
			} catch (error) {
				console.error(error)
				dispatch(auth.actions.logout())
			} finally {
				if (isMounted) {
					setShowSplashScreen(false)
				}
			}
		}

		requestUser()

		return () => {
			isMounted = false
		}
	}, [authToken, user, dispatch])

	return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export default AuthInit
